import { Invoice } from '../../domain/entities/Invoice';
import { InvoiceService } from '../services/InvoiceService';

/**
 * Caso de uso para buscar facturas por número
 */
export class FindInvoiceUseCase {
  private invoiceService: InvoiceService;
  
  /**
   * Constructor del caso de uso
   * @param invoiceService - Servicio de facturas a utilizar
   */
  constructor(invoiceService: InvoiceService) {
    this.invoiceService = invoiceService;
  }
  
  /**
   * Ejecuta el caso de uso para buscar una factura
   * @param invoiceNumber - Número de factura a buscar
   * @returns Objeto con resultado y mensaje
   */
  async execute(invoiceNumber: string): Promise<{
    success: boolean;
    invoice: Invoice | null;
    message?: string;
  }> {
    try {
      // Validamos el número de factura
      if (!invoiceNumber || invoiceNumber.trim() === '') {
        return {
          success: false,
          invoice: null,
          message: 'El número de factura es requerido'
        };
      }
      
      // Buscamos la factura en el repositorio
      const invoice = await this.invoiceService.findInvoice(invoiceNumber);
      
      if (!invoice) {
        return {
          success: false,
          invoice: null,
          message: 'No se encontró ninguna factura con ese número'
        };
      }
      
      return {
        success: true,
        invoice
      };
      
    } catch (error) {
      console.error('Error en FindInvoiceUseCase:', error);
      return {
        success: false,
        invoice: null,
        message: error instanceof Error ? error.message : 'Error al procesar la solicitud'
      };
    }
  }
} 